import { Link, type GeneralLinkProps } from './link';

export const TextLink = (props: GeneralLinkProps) => {
  return (
    <Link
      {...props}
      className='underline text-[var(--mui-palette-text-primary)]'
    >
      {props.children}
    </Link>
  );
};
